import CoreEmailDisclaimer from './CoreEmailDisclaimer';

export { type CoreEmailDisclaimerProps } from './CoreEmailDisclaimer';
export default CoreEmailDisclaimer;
